import type { DiagramSpec } from "../types"

export const brainSystemDiagram: DiagramSpec = {
  id: "brain-system",
  name: "Brain System Architecture",
  description: "How Telegram → Brain Server → Skills → Domains flow",
  layers: [
    { id: "frontend", name: "Frontend", color: "#f472b6" },
    { id: "server", name: "Brain Server", color: "#60a5fa" },
    { id: "skills", name: "Skills", color: "#fbbf24" },
    { id: "domains", name: "Domains", color: "#34d399" },
  ],
  nodes: [
    {
      id: "telegram",
      label: "Telegram",
      layer: "frontend",
      rank: 0,
      description: "60+ chat groups, personas, webhooks",
      type: "Input",
    },
    { id: "slack", label: "Slack", layer: "frontend", rank: 0, description: "Workspace integration via bot token" },
    {
      id: "crons",
      label: "Cron Scheduler",
      layer: "frontend",
      rank: 0,
      description: "Brain-server internal, fires every 60s",
    },
    { id: "dashboard", label: "Dashboard", layer: "frontend", rank: 0, description: "React SPA at /app/*" },

    {
      id: "router",
      label: "Message Router",
      layer: "server",
      rank: 1,
      description: "Routes messages to correct slot/chat",
      fields: { Type: "Hono endpoint", Port: "2777" },
    },
    {
      id: "cc-spawn",
      label: "CC Spawn",
      layer: "server",
      rank: 1,
      description: "executeChat() — spawns claude CLI subprocess",
      fields: { Pattern: "chatId-based", Sessions: "Per-slot resume" },
    },
    {
      id: "lcm",
      label: "LCM Compaction",
      layer: "server",
      rank: 1,
      description: "DAG-based hierarchical summarization",
      fields: { Model: "Haiku 4.5", Cost: "~$0.0004/chunk" },
    },

    { id: "api-ticktick", label: "api-ticktick", layer: "skills", rank: 2, description: "Task management CLI" },
    {
      id: "api-websearch",
      label: "api-websearch",
      layer: "skills",
      rank: 2,
      description: "Perplexity Sonar via OpenRouter",
    },
    { id: "wf-daily", label: "wf-daily-flow", layer: "skills", rank: 2, description: "Morning planning kickoff" },
    { id: "wf-news", label: "wf-ai-news-feed", layer: "skills", rank: 2, description: "AI news digest" },
    { id: "api-linear", label: "api-linear", layer: "skills", rank: 2, description: "Issue tracking integration" },

    {
      id: "wealth",
      label: "Wealth",
      layer: "domains",
      rank: 3,
      description: "Financial decisions, cash flow, investments",
    },
    {
      id: "longevity",
      label: "Longevity",
      layer: "domains",
      rank: 3,
      description: "Health, fitness, nutrition protocols",
    },
    { id: "ops", label: "Ops", layer: "domains", rank: 3, description: "Systems, automation, home ops" },
    {
      id: "aix",
      label: "AIX Business",
      layer: "domains",
      rank: 3,
      description: "Business strategy, VidMax, portfolio",
    },
  ],
  edges: [
    { id: "e-tg-router", source: "telegram", target: "router" },
    { id: "e-sl-router", source: "slack", target: "router" },
    { id: "e-cr-router", source: "crons", target: "router" },
    { id: "e-db-router", source: "dashboard", target: "router" },
    { id: "e-router-cc", source: "router", target: "cc-spawn" },
    { id: "e-cc-lcm", source: "cc-spawn", target: "lcm" },
    { id: "e-cc-tt", source: "cc-spawn", target: "api-ticktick" },
    { id: "e-cc-ws", source: "cc-spawn", target: "api-websearch" },
    { id: "e-cc-daily", source: "cc-spawn", target: "wf-daily" },
    { id: "e-cc-news", source: "cc-spawn", target: "wf-news" },
    { id: "e-cc-linear", source: "cc-spawn", target: "api-linear" },
    { id: "e-daily-wealth", source: "wf-daily", target: "wealth" },
    { id: "e-daily-ops", source: "wf-daily", target: "ops" },
    { id: "e-news-aix", source: "wf-news", target: "aix" },
    { id: "e-tt-ops", source: "api-ticktick", target: "ops" },
    { id: "e-linear-aix", source: "api-linear", target: "aix" },
  ],
  views: [
    { id: "full", name: "Full Architecture", layout: "TB" },
    { id: "server-skills", name: "Server → Skills", layers: ["server", "skills"], layout: "LR" },
    { id: "frontend-server", name: "Frontend → Server", layers: ["frontend", "server"], layout: "TB" },
    { id: "skills-domains", name: "Skills → Domains", layers: ["skills", "domains"], layout: "TB" },
  ],
  defaultView: "full",
}
